import React, { useState, useEffect } from 'react';
import './index.less';
import { parseImage } from '@/utils/media-transfer';
import { getContentArticleList } from './service';
import dsi18n from '@/i18n/ds';
import { DotElement } from '@/components/dots';

function List(props: { clickScene: string }) {
  let pageNo = 1;
  let pageSize = 5;
  let channelName: any = window?.__channelName;
  const { clickScene } = props;
  const [result, setResult] = useState<any>('');
  useEffect(() => {
    let orderStrategy = 'MOST_POPULAR';
    let type: string[];
    type = [channelName];
    getContentArticleList({ type, orderStrategy, pageNo, pageSize })
      .then((res: any) => {
        setResult(res.data);
      })
      .catch(() => {});
  }, [channelName, pageNo, pageSize]);
  return (
    <div className="blog_list">
      <div className="list-title">{dsi18n('PopularArticlesList')}</div>
      {result &&
        result.list.map((item: any) => {
          return (
            <li>
              <DotElement
                dotType="clk"
                dotParams={{
                  scene: clickScene,
                  action: `blog_list_click`,
                  code: item.code,
                }}
                url={item.detailUrl}
                target="_self"
                className="list-section">
                <div className="list-img">
                  <img
                    src={parseImage({
                      img: item.logoUrl,
                    })}
                    alt=""
                  />
                </div>
                <span>{item.name}</span>
              </DotElement>
            </li>
          );
        })}
    </div>
  );
}
export default List;
